import type {PrimaryConfigOptions} from '@/email-maker/grapesjs-email-editor-plugin/src/index';

/**
 * Custom CssRule declarations
 */
export default (opt: PrimaryConfigOptions): void => {
  const {editor} = opt;
  const css = editor.Css;
  const isNewTemplate = !window.PMW.idEmailTemplate;
  const mobileMediaWidth: string | undefined = editor.Devices.get(window.PMW.emails.DEVICE_MOBILE)?.getWidthMedia();

  const globalRuleSelectors: string[] = [
    '.pmw-responsive-table .pmw-responsive-cell',
    '.pmw-responsive-cell',
    '.pmw-responsive-table',
    '.pmw-content-container',
    '.pmw-media-type',
    '.pmw-content-button',
  ];

  if (isNewTemplate) {
    css.clear();
  } else {
    globalRuleSelectors.map((selector) => {
      return css.remove(selector);
    });
  }

  if (!mobileMediaWidth) {
    return;
  }

  css.setRule(
    '.pmw-responsive-table .pmw-responsive-cell',
    {
      width: '100% !important',
      display: 'block',
    },
    {
      atRuleType: 'media',
      atRuleParams: `screen and (max-width: ${mobileMediaWidth})`,
    }
  );

  css.setRule(
    `.${window.PMW.emails.AUTO_WIDTH_CTA_CLASS}`,
    {
      display: 'table !important',
    },
    {
      atRuleType: 'media',
      atRuleParams: `screen and (max-width: ${mobileMediaWidth})`,
    }
  );

  css.setRule(
    '.pmw-responsive-table',
    {
      'min-height': '10px !important',
    },
    {
      atRuleType: 'media',
      atRuleParams: `screen and (max-width: ${mobileMediaWidth})`,
    }
  );

  css.setRule(
    '.pmw-content-container',
    {
      width: '100% !important',
    },
    {
      atRuleType: 'media',
      atRuleParams: `screen and (max-width: ${mobileMediaWidth})`,
    }
  );

  css.setRule(
    '.pmw-media-type',
    {
      width: '100% !important',
    },
    {
      atRuleType: 'media',
      atRuleParams: `screen and (max-width: ${mobileMediaWidth})`,
    }
  );

  css.setRule(
    '.pmw-content-button',
    {
      'min-width': 'fit-content !important',
    },
    {
      atRuleType: 'media',
      atRuleParams: `screen and (max-width: ${mobileMediaWidth})`,
    }
  );
};
